module.exports = ":host .shopping-cart__event-list {\n  border-bottom: 1px solid #c4ceda;\n  margin: 1em 0 0;\n  padding: 0.5em 0 1em; }\n  :host .shopping-cart__event-list:last-child {\n    border-bottom: 0; }\n  :host .shopping-cart__event-list:first-child {\n    margin-top: 0;\n    padding-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shopping-cart/shopping-cart-event-list/event-list.presentation.scss
// module id = gMPt
// module chunks = 12